import { createVNode as i, mergeProps as n } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/QuestionOutlined.js";
import u from "../components/PfIcon.js";
const t = (e, o) => {
  const r = {
    ...e,
    ...o.attrs
  };
  return i(u, n(r, {
    icon: s
  }), null);
};
t.displayName = "QuestionOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
